export default {
  props: {
    filterData: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    field: ({ filterData }) => filterData.field
  },
  methods: {
    removeFilter() {
      this.$emit("removeFilter", this.filterData);
    }
  },
  mounted() {
    this.filterData.handler = this.handler;
  }
};
